import React from "react"
import PropTypes from "prop-types"
import { Icon } from "ui/Icon"
import BlackoutScopeTag from "ui/Blackout/BlackoutScopeTag"
import { REASON_TYPES } from "../constants"
import { isBlackoutReason } from "../utils"
import styles from "./ReasonChip.module.css"

/** The white conflict chip's icon. "Fully booked" is a state, not a warning, so it gets a calendar. */
const CHIP_ICON = { [REASON_TYPES.FULLY_BOOKED]: "Calendar" }

/**
 * One reason for a day's state.
 *
 * Blackouts reuse `BlackoutScopeTag`, which already owns the solid per-scope pill, its icon and
 * the fallback when the server sends no label. Everything else is the white conflict chip.
 */
const ReasonChip = ({ reason }) => {
  if (isBlackoutReason(reason)) {
    return <BlackoutScopeTag scope={reason.scope} label={reason.label} tone="solid" className={styles.scopeTag} />
  }

  return (
    <span className={styles.chip}>
      <Icon name={CHIP_ICON[reason.type] || "AlertTriangle"} width={16} height={16} color="var(--color-text-secondary-dark)" />
      {reason.label}
    </span>
  )
}

ReasonChip.propTypes = {
  reason: PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string,
    scope: PropTypes.string
  }).isRequired
}

export default ReasonChip
